module.exports = __webpack_public_path__ + "fonts/Lexend-400-latin-ext11.2502d16.woff2";